/* eslint-disable clubmed/no-fake-component */
import React from 'react';
import { t } from 'Src/i18n';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { Button } from 'Components/frameworks/button/Button';
import { useCartLocked } from 'Utils/ple-utils';
import { getCtaType } from './transferUtils';
type TransferSelectionButtonProps = {
  bookingId?: string;
  dataSelector: string;
  addedTransfer?: UpsellTransfer | null;
  selectedTransfer: UpsellTransfer | null;
  addTransfer: (arg0: UpsellTransfer) => Promise<unknown>;
  removeTransfer: (arg0: UpsellTransfer) => Promise<unknown>;
  setHasError: (arg0: boolean) => void;
};
export const TransferSelectionButton = ({
  bookingId,
  dataSelector,
  addedTransfer,
  selectedTransfer,
  addTransfer,
  removeTransfer,
  setHasError,
}: TransferSelectionButtonProps) => {
  const { trackClickEvent } = useTrackEvent();
  const [isLoading, setIsLoading] = React.useState(false);
  const { isCartLocked } = useCartLocked(bookingId);
  const ctaType = getCtaType(selectedTransfer, addedTransfer);
  const type = ctaType === 'disabled' ? 'add' : ctaType;
  const isAdd = type === 'add';
  const addLabel = t(`booking.transport.transfer.${isAdd ? 'addTransfer' : 'removeTransfer'}`);
  const price = selectedTransfer?.pricingInfo?.totalPrice?.formattedValue;
  const symbol = isAdd ? '+' : '-';
  const label = price ? `${addLabel} ${symbol}${price}` : addLabel;

  const onCtaClick = async () => {
    const handler = addedTransfer ? removeTransfer : addTransfer;
    setIsLoading(true);
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_UPSELL, {
      detail_click: `${type}_transfer`,
    });

    if (selectedTransfer) {
      await handler(selectedTransfer);
    } else {
      setHasError(true);
    }

    setIsLoading(false);
  };

  if (isCartLocked) {
    return null;
  }

  return (
    <Button
      className="w-full self-end md:w-auto"
      data-selector={`${dataSelector}-${ctaType}`}
      isLoading={isLoading}
      onClick={onCtaClick}
      data-testid={isAdd ? 'transfer-add-cta' : 'transfer-remove-cta'}
      size="large"
    >
      {label}
    </Button>
  );
};
